// src/components/PWABanner.js
import React from "react";
import "./pawbanner.css"; // We'll add CSS next

const PWABanner = () => {
  const [deferredPrompt, setDeferredPrompt] = React.useState(null);
  const [showBanner, setShowBanner] = React.useState(false);

  React.useEffect(() => {
    // Listen for the beforeinstallprompt event (triggered when PWA is installable)
    const handler = (e) => {
      e.preventDefault(); // Prevent mini-infobar from appearing on mobile
      setDeferredPrompt(e);
      setShowBanner(true); // Show our custom banner
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    // Show the native install prompt
    deferredPrompt.prompt();

    // Wait for user response
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("User accepted the install prompt");
    } else {
      console.log("User dismissed the install prompt");
    }

    // Hide banner after decision
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="pwa-banner">
      <div className="pwa-content">
        <div className="pwa-icon">
          <img src="/icons/logo192.png" alt="Xluxe App" />
        </div>
        <div className="pwa-text">
          <h4>Install Xluxe App</h4>
          <p>Shop faster & more privately — add to home screen for quick access</p>
        </div>
        <div className="pwa-actions">
          <button onClick={handleInstall} className="btn-install">
            Install
          </button>
          <button onClick={handleClose} className="btn-close">
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWABanner;